import { Injectable } from '@angular/core';
import { ICategoriaData } from '@core/interfaces/entidades/categoria.entidad';
import { ICrearCategoriaReq } from '@core/interfaces/request-response/categoria.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class CategoriaApiService extends BaseHttpService {
  crear(req: ICrearCategoriaReq) {
    return this.withLoader(
      this.httpClient.post<ICategoriaData>(
        `${environment.apiUrl}${environment.apiPreFix}/categoria/v2/crear`,
        req,
      ),
    );
  }
  cargar() {
    return this.withLoader(
      this.httpClient.get<ICategoriaData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/categoria/v2/cargar`,
      ),
    );
  }
  editar(id: number, data: Partial<ICategoriaData>) {
    return this.withLoader(
      this.httpClient.put<ICategoriaData>(
        `${environment.apiUrl}${environment.apiPreFix}/categoria/v2/editar/${id}`,
        data,
      ),
    );
  }
  eliminar(id: number) {
    return this.withLoader(
      this.httpClient.delete(
        `${environment.apiUrl}${environment.apiPreFix}/categoria/v2/eliminar/${id}`,
      ),
    );
  }
}
